import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'swodoc-node-text',
  templateUrl: 'swodoc-node-text.html',
  changeDetection: ChangeDetectionStrategy.Default,
})
export class SwodocNodeText implements OnInit {
  @Input()
  node: any;
  @Input()
  shouldUpdate: boolean;
  @Output()
  changed: EventEmitter<any> = new EventEmitter<any>();

  // This is the default input field length for HTML
  public characterLimit = 524288;
  public showCharacterLimit = false;

  ngOnInit() {
    if (this.node && this.node.characterLimit && !isNaN(Number(this.node.characterLimit))) {
      this.characterLimit = Number(this.node.characterLimit);
      this.showCharacterLimit = true;
    }
  }

  public convertByGlobalType(value: any, globalType: string) {
    switch (globalType) {
      case '148': {
        //Wundgröße Breite
        let convertedValue = parseFloat(value.replaceAll('.', '').replace(',', '.')) / 10;
        return convertedValue.toLocaleString('de-DE', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        });
      }
      case '149': {
        // Wundgröße Länge
        let convertedValue = parseFloat(value.replaceAll('.', '').replace(',', '.')) / 10;
        return convertedValue.toLocaleString('de-DE', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        });
      }
      case '150': {
        // Wundgröße Tiefe
        let convertedValue = parseFloat(value.replaceAll('.', '').replace(',', '.')) / 10;
        return convertedValue.toLocaleString('de-DE', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        });
      }
      case '181': {
        // Wundgröße Fläche
        let convertedValue = parseFloat(value.replaceAll('.', '').replace(',', '.')) / 100;
        return convertedValue.toLocaleString('de-DE', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 1,
        });
      }
      default: {
        return value;
      }
    }
  }
  public convertBackByGlobalType(value: any, globalType: string) {
    if (!value) {
      return '';
    }
    switch (globalType) {
      case '148': {
        //Wundgröße Breite
        value = this.transformWoundMeasureInput(value);
        let convertedValue;
        convertedValue = parseFloat(value.replaceAll('.', '').replace(',', '.')) * 10;

        if (!Number.isNaN(convertedValue)) {
          return convertedValue.toLocaleString('de-DE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 1,
          });
        } else {
          return '0,0';
        }
      }
      case '149': {
        // Wundgröße Länge
        value = this.transformWoundMeasureInput(value);
        let convertedValue;
        convertedValue = parseFloat(value.replaceAll('.', '').replace(',', '.')) * 10;

        if (!Number.isNaN(convertedValue)) {
          return convertedValue.toLocaleString('de-DE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 1,
          });
        } else {
          return '0,0';
        }
      }
      case '150': {
        // Wundgröße Tiefe
        value = this.transformWoundMeasureInput(value);
        let convertedValue;
        convertedValue = parseFloat(value.replaceAll('.', '').replace(',', '.')) * 10;

        if (!Number.isNaN(convertedValue)) {
          return convertedValue.toLocaleString('de-DE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 1,
          });
        } else {
          return '0,0';
        }
      }
      case '181': {
        // Wundgröße Fläche
        value = this.transformWoundMeasureInput(value);
        let convertedValue;
        convertedValue = parseFloat(value.replaceAll('.', '').replace(',', '.')) * 100;

        if (!Number.isNaN(convertedValue)) {
          return convertedValue.toLocaleString('de-DE', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 1,
          });
        } else {
          return '0,0';
        }
      }
      default: {
        return value;
      }
    }
  }
  public transformWoundMeasureInput(value: any) {
    if (!value) {
      return '';
    }
    let transformedValue = value;
    transformedValue = transformedValue.replaceAll(/[^0-9,]/g, '');
    if ([...transformedValue.matchAll(/,/g)].length > 1) {
      // keep only the leftmost comma
      const firstCommaIndex = transformedValue.indexOf(',');
      transformedValue =
        transformedValue.slice(0, firstCommaIndex + 1) +
        transformedValue.slice(firstCommaIndex + 1).replaceAll(',', '');
    }
    return transformedValue;
  }
  get text(): string {
    if (this.node.responses && this.node.responses.length > 0 && this.node.responses[0].value) {
      if (this.node.globalType) {
        return this.convertByGlobalType(this.node.responses[0].value, this.node.globalType);
      } else {
        return this.node.responses[0].value;
      }
    }
    return '';
  }
  set text(value: string) {
    if (
      this.node.globalType === '148' ||
      this.node.globalType === '149' ||
      this.node.globalType === '150' ||
      this.node.globalType === '181'
    ) {
      const convertedValue = this.convertBackByGlobalType(value, this.node.globalType);
      /// The double emit here is a workaround for the following edge case:
      /// If a current node value is "50" and the user add a letter: "50t". The letters are removed before changing the node value.
      /// Angular therefore does not register a change, even though the view at that moment shows "50t"
      /// To force angular to re-render we change the value to something else and then back to the correct value.

      let skipEmit = false;
      if (value?.[value.length - 1] === ',' && [...value.matchAll(/,/g)].length === 1) {
        // Skip the double emit if a comma was added at the end and there is only one comma in the value
        // This way the user is able to input for example "20," even though the comma is removed in the background
        // Without this skip its impossible to follow up with an input of "20,5" for example
        skipEmit = true;
      }
      if (!skipEmit) {
        this.node.responses = [{ value: 'undefined' }];
        this.changed.emit(this.node);
      }

      this.node.responses = [{ value: convertedValue }];
    } else {
      this.node.responses = [{ value }];
    }
    this.changed.emit(this.node);
  }
}
